import React, { useEffect, useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { UsersIcon, ArrowRightIcon } from 'lucide-react';
export const BuildingAudiencePage = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-4985">
      <Navbar scrolled={scrolled} data-id="element-4986" />
      <main className="pt-24 pb-20" data-id="element-4987">
        <div className="container mx-auto px-4 md:px-6" data-id="element-4988">
          <div className="max-w-4xl mx-auto" data-id="element-4989">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 md:p-12 mb-12 text-white relative overflow-hidden" data-id="element-4990">
              <div className="absolute right-0 bottom-0 opacity-10" data-id="element-4991">
                <UsersIcon className="h-64 w-64" data-id="element-4992" />
              </div>
              <div className="relative z-10" data-id="element-4993">
                <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4994">
                  Building an Audience Before You Launch
                </h1>
                <p className="text-xl opacity-90 max-w-3xl" data-id="element-4995">
                  Discover how to grow an engaged audience before releasing your
                  product so you can launch with momentum and generate immediate
                  interest and sales.
                </p>
              </div>
            </div>
            {/* Main content */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-10 shadow-sm mb-10" data-id="element-4996">
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4997">
                Building an audience before launching your product gives you a
                major advantage. Instead of starting from zero, you launch to
                people who already know and trust you.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4998">
                Start early. Share your progress while you're creating the
                product. This could be small updates, ideas, or
                behind-the-scenes content. It helps people feel involved in the
                process.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4999">
                Focus on providing value. Instead of promoting your product
                right away, share useful insights, tips, or lessons related to
                your niche. This attracts people who are genuinely interested in
                what you're building.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-5000">
                Engagement matters more than numbers. A smaller, active audience
                is more valuable than a large but inactive one. Reply to
                comments, answer questions, and build real connections.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-5001">
                You can also collect emails before launch. Even a simple sign-up
                form can help you gather people who are interested. This gives
                you a direct way to reach them when your product is ready.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-5002">
                When launch day comes, you won't be starting from scratch.
                You'll have an audience that's already paying attention — making
                your launch more effective and more rewarding.
              </p>
            </div>
            {/* Related resources */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm mb-10" data-id="element-5003">
              <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-5004">
                Related Resources
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5005">
                <a href="/learn/marketing-strategy" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-5006">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-5007">
                    How to Market Your Digital Products Effectively
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5008">
                    Learn practical strategies to promote your products and
                    drive consistent sales.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-5009">
                    <span data-id="element-5010">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-5011" />
                  </div>
                </a>
                <a href="/learn/product-descriptions" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-5012">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-5013">
                    Writing Product Listings That Convert
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-5014">
                    Discover how to create compelling product titles and
                    descriptions.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-5015">
                    <span data-id="element-5016">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-5017" />
                  </div>
                </a>
              </div>
            </div>
            {/* CTA */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 text-white text-center" data-id="element-5018">
              <h2 className="text-2xl font-bold mb-4" data-id="element-5019">
                Ready to build your audience?
              </h2>
              <p className="text-lg opacity-90 mb-6 max-w-2xl mx-auto" data-id="element-5020">
                Start sharing your journey today and launch to an audience
                that's already engaged.
              </p>
              <a href="/sell-product" className="inline-block bg-white text-[#0D3C45] px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-all" data-id="element-5021">
                Start Selling
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-5022" />
    </div>;
};